import { Inject } from 'inversify-props'
import { Titulo, EntradaDeTitulo } from '@/models'
import { TituloServiceAdapter } from '../adapter/TituloServiceAdapter';

export class SaveContasAReceberUseCase {
	@Inject('TituloServiceAdapter')
	private tituloServiceAdapter!: TituloServiceAdapter

	async execute(titulo: EntradaDeTitulo): Promise<Titulo> {
		return !titulo.id
			? this.tituloServiceAdapter.create(titulo)
			: this.tituloServiceAdapter.update(titulo)
	}
}
